import * as React from 'react'
export const Bw = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" width="1em" height="1em" {...props}>
    <path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#6da9d2" d="M0 238h513v104H0zM0 0h513v104H0z" />
    <path d="M0 125.5h513v89.656H0z" />
  </svg>
)
